export default {
  shipmentsChart: 'Orders chart',
  usersChart: 'Users chart',
  companiesScoreChart: 'Couriers score chart',
  lineChart: 'Line chart',
  barChart: 'Bar chart',
  person: 'Person',
  userCount: 'User count',
  score: 'Score',
  scoreCount: 'Score count',
  number: 'Number',
  legal: 'Legal',
  real: 'Real',
  companiesShipmentChart: 'Couriers orders chart',
  recentlyActiveCount: 'Recently active count',
  recentlySubmittedCount: 'Recently submitted count'
}
